import { Box } from "@mui/material";

type TimelineMarkerProps = {
  // Half the list's row gap, so adjacent segments meet into one continuous line.
  overhang?: string;
  // Starts the line at the node so the first item does not trail above it.
  isFirst?: boolean;
  // Stops the line at the node so the last item does not trail below it.
  isLast?: boolean;
};

/**
 * A vertical timeline line with a centered node dot, meant to sit in the left
 * gutter of a list item. The parent must be `position: relative`. Line and dot
 * share the same `left` + `translateX(-50%)` anchor so the dot is always
 * centered on the line.
 */
export const TimelineMarker = ({
  overhang = "0.5rem",
  isFirst = false,
  isLast = false,
}: TimelineMarkerProps) => (
  <>
    <Box
      className="bg-teamApp-timeline-fill"
      sx={{
        position: "absolute",
        left: "-1rem",
        top: isFirst ? "50%" : `-${overhang}`,
        bottom: isLast ? "50%" : `-${overhang}`,
        transform: "translateX(-50%)",
        width: "1px",
      }}
    />
    <Box
      className="border border-teamApp-divider-subtle bg-white"
      sx={{
        position: "absolute",
        left: "-1rem",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "0.625rem",
        height: "0.625rem",
        borderRadius: "50%",
        zIndex: 1,
      }}
    />
  </>
);
